/* tslint:disable */
/* eslint-disable */
/**
 * Midcoast Water Bureau API
 * Backend API documentation for Midcoast Water Bureau application. This API provides endpoints for user management, device monitoring, water meter measurements, and notification systems.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: support@nucleus3.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { DeleteFCMRequest } from '../n3-backend-open-api-gen/model';
// @ts-ignore
import type { RegisterFCMRequest } from '../n3-backend-open-api-gen/model';
/**
 * NotificationV2ControllerApi - axios parameter creator
 */
export const NotificationV2ControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {RegisterFCMRequest} registerFCMRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerToken: async (registerFCMRequest: RegisterFCMRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'registerFCMRequest' is not null or undefined
            assertParamExists('registerToken', 'registerFCMRequest', registerFCMRequest)
            const localVarPath = `/api/v2/fcm`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(registerFCMRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DeleteFCMRequest} deleteFCMRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unregisterToken: async (deleteFCMRequest: DeleteFCMRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deleteFCMRequest' is not null or undefined
            assertParamExists('unregisterToken', 'deleteFCMRequest', deleteFCMRequest)
            const localVarPath = `/api/v2/fcm`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deleteFCMRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * NotificationV2ControllerApi - functional programming interface
 */
export const NotificationV2ControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = NotificationV2ControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {RegisterFCMRequest} registerFCMRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async registerToken(registerFCMRequest: RegisterFCMRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.registerToken(registerFCMRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationV2ControllerApi.registerToken']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {DeleteFCMRequest} deleteFCMRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unregisterToken(deleteFCMRequest: DeleteFCMRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unregisterToken(deleteFCMRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationV2ControllerApi.unregisterToken']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * NotificationV2ControllerApi - factory interface
 */
export const NotificationV2ControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = NotificationV2ControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {RegisterFCMRequest} registerFCMRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerToken(registerFCMRequest: RegisterFCMRequest, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.registerToken(registerFCMRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DeleteFCMRequest} deleteFCMRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unregisterToken(deleteFCMRequest: DeleteFCMRequest, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.unregisterToken(deleteFCMRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * NotificationV2ControllerApi - object-oriented interface
 */
export class NotificationV2ControllerApi extends BaseAPI {
    /**
     * 
     * @param {RegisterFCMRequest} registerFCMRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public registerToken(registerFCMRequest: RegisterFCMRequest, options?: RawAxiosRequestConfig) {
        return NotificationV2ControllerApiFp(this.configuration).registerToken(registerFCMRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DeleteFCMRequest} deleteFCMRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public unregisterToken(deleteFCMRequest: DeleteFCMRequest, options?: RawAxiosRequestConfig) {
        return NotificationV2ControllerApiFp(this.configuration).unregisterToken(deleteFCMRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

